import React, { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import ModalDeleteFile from './ModalDeleteFile'
import ModalScreenManager from './ModalScreenmanager';
import { useParams, useNavigate  } from 'react-router-dom';

// import { useNavigate } from 'react-router-dom';

function ImageManager() {
    const [datas, setDate] = useState([])
    const [showModal, setShowModal] = useState(false);
    const [nameFile, setNameFile] = useState();
    const [showVideo, setShowVideo] = useState(false);
    const [search, setSearch] = useState('');
    const [sortedBy, setSortedBy] = useState();
    const [counter, setCounter] = useState(0)
    const [choosenDirectory, setChoosenDirectory] = useState({
        fileName: '',
        fileDate: '',
        fileSize: '',
        isDir: '',
        firstDirName: ''
    });
    // const [open, setOpen] = useState('block')


    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    let { id_pdv } = useParams();
    const navigate = useNavigate();

    // const navigate = useNavigate();

    console.log(`SI ${id_pdv}`);

    useEffect(() => {
        // console.log('This is a Hook');
        if(!id_pdv){
            directory()
        }else{
            dirFile(id_pdv)
        }
        }, [])
        
    function dirFile(dirName) {
        console.log(dirName);
        choosenDirectory.firstDirName = dirName
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/listScreen/${dirName}`)
            .then(res => {
                // console.log(new Date(res.data[0].fileDate).toUTCString());
                // setDate(res.data)
                setDate(res.data.sort((a, b) => (new Date(a.fileDate).toLocaleDateString("fr") < new Date(b.fileDate).toLocaleDateString("fr")) ? 1 : -1))

            })
            .catch(err => console.log(err))
    }

    function directory(){
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/listScreen`)
        .then(res => {
            // console.log(new Date(res.data[0].fileDate).toUTCString());
            console.log(res.data);
            setDate(res.data.sort((a, b) => (new Date(a.fileDate).toLocaleDateString("fr") < new Date(b.fileDate).toLocaleDateString("fr")) ? 1 : -1))
            console.log(res.data);
        })
        .catch(err => console.log(err))
    }

    function backToDir(){
        navigate('/imagemanager'); // Navigate to the route without parameters
        window.location.reload()
    }
    function greaterThanZero(value) {
        if (value < 10) {
            return `0${value}`
        } else {
            return value
        }
    }

    const sorted = datas.sort((a, b) => {

        const aVal = a[sortedBy];
        const bVal = b[sortedBy];


        if (sortedBy === 'fileDate') {
            if (counter % 2 === 0) {
                return new Date(bVal)
            } else {
                return new Date(aVal)
            }
        } else {
            if (typeof aVal === "number" && typeof bVal === "number") {
                if (counter % 2 === 0) return aVal - bVal;
                else return bVal - aVal;
            }
            else if (typeof aVal === "string" && typeof bVal === "string") {
                if (counter % 2 === 0) return aVal.localeCompare(bVal);
                else return bVal.localeCompare(aVal);
            }
            return 1;
        }
    });

    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                {/* <Header /> */}
                <div className="mb-6">
                    <h1 className="text-xl font-semibold text-slate-800">Gestion des écrans</h1>
                    <p className="text-sm text-slate-500">Parcourez et prévisualisez les captures d'écran des points de vente.</p>
                </div>

                <div className="mb-4 max-w-md">
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden` ? 'block' : 'hidden')} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg> */}
                    <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                            type="text"
                            id="search"
                            placeholder="Rechercher..."
                            onChange={(e) => setSearch(e.target.value)} />
                    </div>
                </div>

                <main>
                    {/* <DefaultSidebar isOpen={open} /> */}

                    <div className="w-full">
                        <button type="button" className="mb-4 flex h-9 items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50" onClick={() => backToDir()}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Retour
                        </button>
                        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                            <div className="overflow-x-auto">
                                <table className="w-full text-left text-sm text-slate-700">
                                    <thead className="border-b border-slate-200 bg-slate-50">
                                        <tr>
                                            <th scope="col" className="w-1/3 cursor-pointer px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500" onClick={() => { setSortedBy('fileName'); setCounter(counter + 1) }}>
                                                PIN CODE
                                            </th>
                                            <th scope="col" className="w-1/3 cursor-pointer px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500" onClick={() => { setSortedBy('fileDate'); setCounter(counter + 1) }}>
                                                Date
                                            </th>
                                            <th scope="col" className="w-1/3 cursor-pointer px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500" onClick={() => { setSortedBy('fileSize'); setCounter(counter + 1) }}>
                                                Taille
                                            </th>
                                            <th scope="col" className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                </svg>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* {datas.length !== 0 ? Array.from(datas).map((data, index) => { */}
                                        {datas.length !== 0 ? sorted.filter((item) => {
                                            return search.toLowerCase() === ''
                                                ? item
                                                : item.fileName.toLowerCase().includes(search.toLowerCase())
                                        }).map((data, index) => {
                                    if (data.isDir) {
                                        return (

                                            <tr className="cursor-pointer border-b border-slate-100 bg-slate-50/60 hover:bg-indigo-50/40" onClick={() => { dirFile(data.fileName) }}>

                                                <td className="px-4 py-3 text-sm font-semibold text-slate-800">
                                                    {data.fileName}
                                                </td>
                                                <td className="px-4 py-3 text-sm text-slate-700">
                                                    {/* {new Date(data.fileDate).toUTCString()} */}
                                                    {greaterThanZero(new Date(data.fileDate).getUTCDate())}/{greaterThanZero(new Date(data.fileDate).getUTCMonth() + 1)}/{greaterThanZero(new Date(data.fileDate).getUTCFullYear())}  {greaterThanZero(new Date(data.fileDate).getUTCHours() + 2)}:{greaterThanZero(new Date(data.fileDate).getUTCMinutes())}
                                                </td>
                                                <td className="px-4 py-3 text-sm text-slate-700">
                                                    {data.fileSize}
                                                </td>
                                                {/* <td className="px-6 py-4 text-center" >
                                                    <button value={data.fileName} className="font-medium text-red-600 dark:text-red-500 hover:underline"  onClick={() => {setShowModal(true); setNameFile(data.fileName)}} >X</button>
                                                </td> */}
                                                <td className="px-4 py-3 text-center text-slate-500" >
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="mx-auto h-5 w-5">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
                                                    </svg>

                                                </td>
                                            </tr>
                                        )
                                    } else {
                                        return (
                                            <tr className="cursor-pointer border-b border-slate-100 hover:bg-indigo-50/40" onClick={() => { setShowVideo(true); setChoosenDirectory({ ...choosenDirectory, fileName: data.fileName, fileDate: data.fileDate, fileSize: data.fileSize }) }}>

                                                <td className="px-4 py-3 text-sm font-semibold text-slate-800">
                                                    {data.fileName}
                                                </td>
                                                <td className="px-4 py-3 text-sm text-slate-700">
                                                    {/* {new Date(data.fileDate).toUTCString()} */}
                                                    {greaterThanZero(new Date(data.fileDate).getUTCDate())}/{greaterThanZero(new Date(data.fileDate).getUTCMonth() + 1)}/{greaterThanZero(new Date(data.fileDate).getUTCFullYear())}  {greaterThanZero(new Date(data.fileDate).getUTCHours() + 2)}:{greaterThanZero(new Date(data.fileDate).getUTCMinutes())}
                                                </td>
                                                <td className="px-4 py-3 text-sm text-slate-700">
                                                    {data.fileSize}
                                                </td>
                                                <td className="px-4 py-3 text-center" >
                                                    <button value={data.fileName} className="font-medium text-red-600 hover:underline" onClick={() => { setShowModal(true); setNameFile(choosenDirectory.firstDirName === '' ? data.fileName : choosenDirectory.firstDirName + '/' + data.fileName) }} >X</button>
                                                </td>
                                            </tr>
                                        )
                                    }
                                }) : <tr className="border-b border-slate-100"></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="fixed bottom-16 right-6 h-10 w-10 cursor-pointer text-slate-500 hover:text-indigo-500" onClick={() => scrollToTop()}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                </main>
            </div>
            <ModalScreenManager isVisible={showVideo} onClose={() => setShowVideo(false)} videoDati={choosenDirectory} />
            <ModalDeleteFile isVisible={showModal} onClose={() => setShowModal(false)} nameFile={nameFile} />
        </Fragment>
    )
}
export default ImageManager;